var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#BCF0DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6957 6.20495C13.8269 6.33622 13.9006 6.51424 13.9006 6.69985C13.9006 6.88547 13.8269 7.06348 13.6957 7.19475L8.09567 12.7948C7.9644 12.926 7.78639 12.9997 7.60077 12.9997C7.41516 12.9997 7.23714 12.926 7.10587 12.7948L4.30587 9.99475C4.17836 9.86273 4.10781 9.68591 4.1094 9.50237C4.111 9.31883 4.18461 9.14326 4.3144 9.01348C4.44419 8.88369 4.61975 8.81007 4.80329 8.80848C4.98683 8.80688 5.16365 8.87744 5.29567 9.00495L7.60077 11.3101L12.7059 6.20495C12.8371 6.07372 13.0152 6 13.2008 6C13.3864 6 13.5644 6.07372 13.6957 6.20495Z",
    fill: "#31C48D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapes);
export default __webpack_public_path__ + "static/media/icon-shapes.ab7bba073db9b68db4eeb10baeac5954.svg";
export { ForwardRef as ReactComponent };